import { render, staticRenderFns } from "./FilterButtons.vue?vue&type=template&id=4108b2f6&scoped=true&"
import script from "./FilterButtons.vue?vue&type=script&lang=js&"
export * from "./FilterButtons.vue?vue&type=script&lang=js&"
import style0 from "./FilterButtons.vue?vue&type=style&index=0&id=4108b2f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4108b2f6",
  null
  
)

export default component.exports